import { FormGroup } from '@angular/forms';

import {
  BoardOutputBehaviour,
  BoardOutputType,
  BoardProgressType,
  BoardSourceType,
  BoardType,
} from '../interfaces/board.enums';

export function updateFormForBoardType(value: BoardType, form: FormGroup): void {
  const settings = getBoardFormValues()[value];
  if (settings) {
    form.controls.progressType.setValue(settings.progressType);
    form.controls.datasource.setValue(settings.datasource);
    form.controls.outputAction.setValue(settings.outputAction);
    form.controls.outputBehaviour.setValue(settings.outputBehaviour);
    form.controls.boardCellColor.setValue(settings.boardCellColor);
  }
}

export function getBoardFormValues(): any {
  return {
    [BoardType.MakeReady]: {
      progressType: BoardProgressType.UpdateMakeReadyProgressBar,
      datasource: BoardSourceType.MakeReadyUnits,
      outputAction: BoardOutputType.SendToApproval,
      outputBehaviour: BoardOutputBehaviour.Automatically,
      boardCellColor: '#ffffff',
    },
    [BoardType.Reno]: {
      progressType: BoardProgressType.UpdateRENOProgressBar,
      datasource: BoardSourceType.RenoUnits,
      outputAction: BoardOutputType.SendToApproval,
      outputBehaviour: BoardOutputBehaviour.Automatically,
      boardCellColor: '#f5fbfb',
    },
    [BoardType.Marketing]: {
      progressType: BoardProgressType.None,
      datasource: BoardSourceType.UnleasedUnits,
      outputAction: BoardOutputType.None,
      outputBehaviour: null,
      boardCellColor: '#fafffa',
    },
    [BoardType.LeaseUp]: {
      progressType: BoardProgressType.UpdateLeaseUpProgressBar,
      datasource: BoardSourceType.LeaseUpUnits,
      outputAction: BoardOutputType.None,
      outputBehaviour: BoardOutputBehaviour.Manually,
      boardCellColor: '#EFFBEF',
    },
    [BoardType.Prelease]: {
      progressType: BoardProgressType.None,
      datasource: BoardSourceType.PreleaseUnits,
      outputAction: BoardOutputType.None,
      outputBehaviour: BoardOutputBehaviour.Manually,
      boardCellColor: '#FCF9FC',
    },
    [BoardType.Eviction]: {
      progressType: BoardProgressType.UpdateNoticeProgressBar,
      datasource: BoardSourceType.UnitsInNoticeUnderEviction,
      outputAction: BoardOutputType.SendToMoveOut,
      outputBehaviour: BoardOutputBehaviour.Automatically,
      boardCellColor: '#FFF7F7',
    },
    [BoardType.MoveIn]: {
      progressType: BoardProgressType.UpdateMoveInProgressBar,
      datasource: BoardSourceType.UnitsInMoveIn,
      outputAction: BoardOutputType.SendToArchive,
      outputBehaviour: BoardOutputBehaviour.Automatically,
      boardCellColor: '#ffffff',
    },
    [BoardType.MoveOut]: {
      progressType: BoardProgressType.UpdateMoveOutProgressBar,
      datasource: BoardSourceType.MoveOutUnits,
      outputAction: BoardOutputType.SendToMakeReady,
      outputBehaviour: BoardOutputBehaviour.Automatically,
      boardCellColor: '#ffffff',
    },
    [BoardType.Approval]: {
      progressType: BoardProgressType.UpdateApprovalProgressBar,
      datasource: BoardSourceType.NonPmsUnits,
      outputAction: BoardOutputType.SendToArchive,
      outputBehaviour: BoardOutputBehaviour.Automatically,
      boardCellColor: '#ffffff',
    },
    [BoardType.NonPms]: {
      progressType: BoardProgressType.None,
      datasource: BoardSourceType.NonPmsUnits,
      outputAction: BoardOutputType.SendToArchive,
      outputBehaviour: BoardOutputBehaviour.Automatically,
      boardCellColor: '#fdfdf2',
    },
    [BoardType.Custom]: {
      progressType: BoardProgressType.None,
      datasource: BoardSourceType.Manual,
      outputAction: BoardOutputType.None,
      outputBehaviour: BoardOutputBehaviour.Automatically,
      boardCellColor: '#ffffff',
    },
  };
}
